export default class GenericReferencialDto {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
    }
}